import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.98805 7.49992C8.4377 7.50017 8.66295 8.04366 8.34498 8.36174L6.35719 10.35C6.16011 10.547 5.84011 10.547 5.64283 10.35L3.65504 8.36174C3.33705 8.04364 3.56216 7.50002 4.01197 7.49992H7.98805Z" fill="currentColor" />
      <path d="M5.64283 1.64982C5.82769 1.46499 6.12026 1.45344 6.31861 1.61515L6.35719 1.64982L8.34498 3.63761C8.6627 3.95567 8.43769 4.49967 7.98805 4.49992H4.01197C3.56217 4.49982 3.33691 3.95573 3.65504 3.63761L5.64283 1.64982Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6507 10.0002C11.2503 10.0006 11.5506 10.7252 11.1266 11.1493L8.47625 13.8003C8.21348 14.063 7.78681 14.063 7.52378 13.8003L4.87339 11.1493C4.4494 10.7252 4.74954 10.0004 5.3493 10.0002H10.6507Z" fill="currentColor" />
      <path d="M7.52378 2.20009C7.77025 1.95364 8.16035 1.93824 8.42482 2.15386L8.47625 2.20009L11.1266 4.85048C11.5503 5.27455 11.2503 5.99988 10.6507 6.00022H5.3493C4.74956 6.00008 4.44922 5.27463 4.87339 4.85048L7.52378 2.20009Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3135 12.5005C14.063 12.5009 14.4384 13.4067 13.9084 13.9369L10.5954 17.2507C10.267 17.579 9.73364 17.579 9.40484 17.2507L6.09185 13.9369C5.56187 13.4067 5.93705 12.5007 6.68674 12.5005H13.3135Z" fill="currentColor" />
      <path d="M9.40484 2.75035C9.71294 2.4423 10.2006 2.42304 10.5311 2.69257L10.5954 2.75035L13.9084 6.06334C14.438 6.59344 14.0629 7.5001 13.3135 7.50052H6.68674C5.93707 7.50034 5.56165 6.59354 6.09185 6.06334L9.40484 2.75035Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.98805 7.49992C8.4377 7.50017 8.66295 8.04366 8.34498 8.36174L6.35719 10.35C6.16011 10.547 5.84011 10.547 5.64283 10.35L3.65504 8.36174C3.33705 8.04364 3.56216 7.50002 4.01197 7.49992H7.98805Z" fill="currentColor" />
      <path d="M5.64283 1.64982C5.82769 1.46499 6.12026 1.45344 6.31861 1.61515L6.35719 1.64982L8.34498 3.63761C8.6627 3.95567 8.43769 4.49967 7.98805 4.49992H4.01197C3.56217 4.49982 3.33691 3.95573 3.65504 3.63761L5.64283 1.64982Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6507 10.0002C11.2503 10.0006 11.5506 10.7252 11.1266 11.1493L8.47625 13.8003C8.21348 14.063 7.78681 14.063 7.52378 13.8003L4.87339 11.1493C4.4494 10.7252 4.74954 10.0004 5.3493 10.0002H10.6507Z" fill="currentColor" />
      <path d="M7.52378 2.20009C7.77025 1.95364 8.16035 1.93824 8.42482 2.15386L8.47625 2.20009L11.1266 4.85048C11.5503 5.27455 11.2503 5.99988 10.6507 6.00022H5.3493C4.74956 6.00008 4.44922 5.27463 4.87339 4.85048L7.52378 2.20009Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3135 12.5005C14.063 12.5009 14.4384 13.4067 13.9084 13.9369L10.5954 17.2507C10.267 17.579 9.73364 17.579 9.40484 17.2507L6.09185 13.9369C5.56187 13.4067 5.93705 12.5007 6.68674 12.5005H13.3135Z" fill="currentColor" />
      <path d="M9.40484 2.75035C9.71294 2.4423 10.2006 2.42304 10.5311 2.69257L10.5954 2.75035L13.9084 6.06334C14.438 6.59344 14.0629 7.5001 13.3135 7.50052H6.68674C5.93707 7.50034 5.56165 6.59354 6.09185 6.06334L9.40484 2.75035Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconCaretUpDown: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"caret-up-down"} {...props} />
);
